import { useNavigate } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'

/**
 * What a client sees instead of a portal page they cannot open. A page the
 * stage hides, a page with nothing in it yet and a URL that never existed all
 * land here saying the same thing, so a client cannot work out from the portal
 * that a document exists but has not been published to them.
 */
export default function PortalUnavailable() {
  const navigate = useNavigate()

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', py: 8, textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        This page isn't available yet.
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Your strategist will open it up as your search moves forward. Your Dashboard has
        everything that's ready for you right now.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/portal')}>
        Go to Dashboard
      </Button>
    </Box>
  )
}
